import { TaskListWaitingTabViewProps } from "./types/taskListWaitingTabViewProps";
import './taskListWaitingTabView.scss'
import { HeadersTable, joinData } from "../../../../helpers/featureTableConstruct";
import { CellContext, createColumnHelper, Row } from "@tanstack/react-table";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import Table from "../../../../components/shared/table/table";
import SlideoutWrapper from "../../../../components/slideoutWrapper/slideoutWrapper";
import { SlideoutBtnPosition } from "../../../../components/slideoutWrapper/types/slideoutWrapperProps";
import { ReactComponent as MapIcon } from '../../../../icons/map.svg';
import WebMap from "../../../../components/webmap/webmap";
import { useCallback, useContext, useEffect, useState } from "react";
import { apiContext } from "../../../../contexts/apiContext";
import ViewContext from "../../../../contexts/viewContext";
import { ObjectState } from "../types/tasklListViewProps";
import { getPdfCard } from "../../../../services/registrationCardService/registrationCardService";
import { notifyError, notifyWarn } from "../../../../components/snackbar/snackbar";
import PermissionsContext from "../../../../contexts/permissionsContext";
import { ObjectType } from "../../../../contexts/types/card";
import { canBeEdited, canBeVerified, checkAssigment } from "../../../../helpers/permissionsHelper";
import { TableContext } from "../../../../contexts/tableContext";
import Modal from "../../../../components/modalWindow/modal";
import PdfViewerModal from "../modals/pdfViewerModal/pdfViewerModal";
import AuthContext from "../../../../contexts/authContext";
import AdminDecisionModal from "../modals/adminDecisionModal/adminDecisionModal";
import { AdminDecisionModalProps } from "../modals/adminDecisionModal/types/adminDecisionModalProps";

const TaskListWaitingTabView = (props: TaskListWaitingTabViewProps) => {
    const api = useContext(apiContext);
    const { userRoles, username } = useContext(AuthContext);
    const { setViewType, setViewData, viewTypes } = useContext(ViewContext);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);
    const [loading, setLoading] = useState<boolean>(false);
    const { setCheckboxesTable } = useContext(TableContext);
    const [getPdfView, setGetPdfView] = useState<boolean>(false);
    const [pdfData, setPdfData] = useState<any>(undefined);
    const [showAdminDecisionModal, setShowAdminDecisionModal] = useState<boolean>(false);
    const [rowData, setRowData] = useState<any>(undefined);

    useEffect(() => {
        setCheckboxesTable([]);
    }, [setCheckboxesTable])

    const onPdfViewHandler = (waitingRoomId: string) => {
        setLoading(true);
        getPdfCard(api.apiUrl + api.apiVersion, waitingRoomId).then((response: any) => {
            const arrayBuffer = response;
            setPdfData(arrayBuffer);
            setGetPdfView(true);
            setLoading(false);
        }).catch((error) => {
            if (error) {
                error.text().then((text: any) => {
                    notifyError({ message:  text});
                });
            }
            else {
                notifyError({ message: "Błąd podczas tworzenia podglądu. Spróbuj ponownie za 1 minutę" });
            }
            setLoading(false);
        })

    }

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"taskList"} //properties.row.getValue('ObjectType')}
            editClickHandler={handleEditClick}
            personAddClickHandler={props.handlePersonAddClick}
            getPdfClickHandler={onPdfViewHandler}
            adminDecisionHandler={handleAdminDecisionClick}
        />)
    }

    const handleAdminDecisionClick = (row: any) => {
        if (functionsPermissions.addGeometry.active) {
            setRowData(row);
            setShowAdminDecisionModal(true);
        }
    }

    const onCloseAdminDecisionModal = () => {
        setTimeout(() => {
            setShowAdminDecisionModal(false);
        }, 0.1)
    }

    var adminDecisionModalProps: AdminDecisionModalProps = {
        onClose: onCloseAdminDecisionModal,
        waitingRoomRec: rowData,
        handleAssigneEditorClick: props.handlePersonAddClick,
        setAdminDecisionRow: props.setAdminDecisionRow
    }

    const handleEditClick = (row: any) => {
        const waitingroom = row.attributes;
        const objectType: ObjectType = waitingroom.RODZAJ_OBIEKTU;
        const objectStatus = waitingroom.STAN_OBIEKTU_DOM;
        var isKR = objectType === ObjectType.KRO || objectType === ObjectType.KRTZ;

        const assignedUser = waitingroom.PRZYPISANY_UZYTKOWNIK;
        const isAssigment = checkAssigment(username, assignedUser, userRoles);

        if (objectStatus !== ObjectState.DownloadedForEdition && objectStatus !== ObjectState.DownloadedForVerification) {
            if (isAssigment && canBeEdited(functionsPermissions, waitingroom, extendedUserPermissions, undefined, true)) {
                if (isKR) {
                    setViewData({ row: row, editMode: true, local: false });
                    setViewType(viewTypes.KRForm);
                }
                else {
                    setViewData({ row: row, local: false});
                    setViewType(viewTypes.POForm);
                }
            }
            else if (isAssigment && canBeVerified(functionsPermissions, objectStatus)) {
                if (isKR) {
                    setViewData({ row: row, editMode: false, local: false });
                    setViewType(viewTypes.KRForm);
                }
            }
        }
        else {
            notifyWarn({ message: "Nie można edytować karty, która jest pobrana na komputer osobisty" });
        }
    }

    const prepareData = useCallback(() => {
        return joinData(props.data, props.extraSelection);
    }, [props.extraSelection, props.data])

    const isEqual = (feature: any, row: Row<any>) => {
        if (!row.original.attributes) {
            row.original.attributes = row.original;
        }
        return feature.attributes.ID === row.original.attributes.ID && feature.attributes.RODZAJ_OBIEKTU === row.original.attributes.RODZAJ_OBIEKTU;
    }

    var columns = Object.keys(props.headers).filter(item => item !== "TERYT" && item !== "SHAPE_YES_NO");

    const compareId = (row1: Row<any>, row2: Row<any>) => {
        if (!row1.original.attributes) {
            row1.original.attributes = row1.original;
        }
        if (!row2.original.attributes) {
            row2.original.attributes = row2.original;
        }
        return row1.original.attributes.NUMER_IDENTYFIKACYJNY === row2.original.attributes.NUMER_IDENTYFIKACYJNY &&
            row1.original.attributes.RODZAJ_OBIEKTU === row2.original.attributes.RODZAJ_OBIEKTU &&
            row1.original.attributes.GLOBALID === row2.original.attributes.GLOBALID;
    }

    var tableProps: TableProps = {
        columnAliases: props.headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: columns,
        cellActions: cellAction,
        data: prepareData(),
        columnConfig: props.columnConfig,
        extraSelection: props.extraSelection,
        selection: props.selection,
        onTrClick: props.onTrClick,
        rowCompare: isEqual,
        compareId: compareId,
        loading: props.loading || loading,
        firstColumnCheckbox: true,
        tableFiltersVisible: true,
        isPagination: props.isPagination,
        pagination: props.pagination,
        setPagination: props.setPagination,
        allCount: props.allCount,
        pageCount: props.pageCount,
        setPageCount: props.setPageCount,
        onPaginationChange: props.onPaginationChange,
        shiftSelection: true,
        scrollable: true,
        threeDots: true,
        threeDotsProps: {
            menuItemClass: 'threeDotsMenuItem',
            editOnClick: props.threeDotsProps?.editOnClick,
            collectiveEditOnClick: props.threeDotsProps?.collectiveEditOnClick,
            validateOnClick: props.threeDotsProps?.validateOnClick,
            cancelOAndKOnClick: props.threeDotsProps?.cancelOAndKOnClick,
            cancelAAndNClick: props.threeDotsProps?.cancelAAndNClick,
            table: props.threeDotsProps?.table,
            markStatus: props.threeDotsProps?.markStatus,
            assignEditorOnClick: props.threeDotsProps?.assignEditorOnClick,
            assignVerifierOnClick: props.threeDotsProps?.assignVerifierOnClick,
            automaticVerificationClick: props.threeDotsProps?.automaticVerificationClick,
            downloadCardClick: props.threeDotsProps?.downloadCardClick
        }
    }

    const onClosePdfViewer = () => {
        setGetPdfView(false);
    }

    return (<div className="TaskListWaitingTabView">
        <Table {...tableProps} />
        {functionsPermissions.showObjGeomOnMap.active &&
            <SlideoutWrapper icon={MapIcon} btnPos={SlideoutBtnPosition.Left}>
                <WebMap config={api.mapComposition.waitingRoom} baseMap={api.baseMap} />
            </SlideoutWrapper>
        }
        {showAdminDecisionModal && <AdminDecisionModal {...adminDecisionModalProps} />}
        {getPdfView &&
            <Modal
                title={"Podgląd"}
                width="90vw"
                height="90vh"
                onClose={onClosePdfViewer}
                bodyClassName="modalBodyAutoVerification"
            >
                <PdfViewerModal pdfData={pdfData} />
            </Modal>
        }
    </div>);
}

export default TaskListWaitingTabView;